import { useEffect, useState } from "react";

import { useMediaQuery, useTheme } from "@mui/material";

// Custom hook to detect and log the current breakpoint
export const useBreakpointLogger = () => {
  const theme = useTheme();

  // Define media queries for each breakpoint
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));

  const [currentBreakpoint, setCurrentBreakpoint] = useState<string>("xs");

  useEffect(() => {
    if (isXs) {
      setCurrentBreakpoint("xs");
    } else if (isSm) {
      setCurrentBreakpoint("sm");
    } else if (isMd) {
      setCurrentBreakpoint("md");
    } else if (isLg) {
      setCurrentBreakpoint("lg");
    } else if (isXl) {
      setCurrentBreakpoint("xl");
    }
    // eslint-disable-next-line no-console
    console.log(`Current breakpoint: ${currentBreakpoint}`);
  }, [isXs, isSm, isMd, isLg, isXl, currentBreakpoint]);

  return currentBreakpoint;
};
